import { useTranslation } from 'react-i18next'
import { twJoin } from 'tailwind-merge'
import { LibraryElementTypes } from '../../../../enums/libraryElementTypes'
import Column3333Icon from './icons/column-3-3-3-3-icon'
import Column444Icon from './icons/column-4-4-4-icon'
import Column66Icon from './icons/column-6-6-icon'
import ColumnRowIcon from './icons/column-row-icon'
import libraryElements from './libraryElements'
import { LibraryItem, LibraryItemDraggable } from './LibraryItem'

type LibraryElementProps = {
  type: keyof typeof LibraryElementTypes
  onClick?: () => void
}

const BASE_ICON_CLASSNAME =
  'fill-fill-primary group-hover:fill-brand-primary h-[40px] w-[40px] main-transition-colors'

const LibraryElement = ({ type, onClick }: LibraryElementProps) => {
  const { t } = useTranslation()

  const libraryElement = libraryElements[type]

  const getIcon = () => {
    switch (type) {
      case LibraryElementTypes.LibraryLayout_12:
        return <ColumnRowIcon className={BASE_ICON_CLASSNAME} />
      case LibraryElementTypes.LibraryLayout_6_6:
        return <Column66Icon className={BASE_ICON_CLASSNAME} />
      case LibraryElementTypes.LibraryLayout_4_4_4:
        return <Column444Icon className={BASE_ICON_CLASSNAME} />
      case LibraryElementTypes.LibraryLayout_3_3_3_3:
        return <Column3333Icon className={BASE_ICON_CLASSNAME} />
      default:
        return (
          <i
            className={twJoin(
              libraryElements[type].className,
              'text-fill-primary group-hover:text-brand-primary main-transition-colors group-hover:fill-brand-primary text-[40px]',
            )}
          />
        )
    }
  }

  const LibraryItemComponent = onClick ? LibraryItem : LibraryItemDraggable

  return (
    <LibraryItemComponent type={type} onClick={onClick}>
      {getIcon()}

      {'title' in libraryElement && <span className="text-center">{t(libraryElement.title)}</span>}
    </LibraryItemComponent>
  )
}

export default LibraryElement
